import { FilterOptions } from './state';

const filterOptions2024B: FilterOptions = {
  demographics: [
    {
      question: 'Gender',
      id: 2,
      icon: 'las la-clone',
      answers: [
        {
          value: 1,
          label: 'Male'
        },
        {
          value: 2,
          label: 'Female'
        },
        {
          value: 3,
          label: 'Other'
        }
      ]
    },
    {
      question: 'Age',
      id: 3,
      icon: 'las la-birthday-cake',
      answers: [
        {
          value: '1',
          label: '18-24 years'
        },
        {
          value: '2',
          label: '25-34 years'
        },
        {
          value: '3',
          label: '35-44 years'
        },
        {
          value: '4',
          label: '45-54 years'
        },
        {
          value: '5',
          label: '55-64 years'
        },
        {
          value: '6',
          label: '65-74 years'
        },
        {
          value: '7',
          label: '75+ years'
        }
      ]
    },
    {
      question: 'Civil Status',
      id: 5,
      icon: 'las la-ring',
      answers: [
        {
          value: 1,
          label: 'Single'
        },
        {
          value: 2,
          label: 'In a relationship'
        },
        {
          value: 3,
          label: 'Co-habiting/Married'
        }
      ]
    },
    // {
    //   question: 'Age of children/shared children',
    //   id: 1006,
    //   icon: 'las la-child',
    //   answers: [
    //     {
    //       value: 1,
    //       label: 'Do not have children/Do not have children living at home'
    //     },
    //     {
    //       value: 2,
    //       label: '0-1 year'
    //     },
    //     {
    //       value: 3,
    //       label: '2 years'
    //     },
    //     {
    //       value: 4,
    //       label: '3 years'
    //     },
    //     {
    //       value: 5,
    //       label: '4 years'
    //     },
    //     {
    //       value: 6,
    //       label: '5 years'
    //     },
    //     {
    //       value: 7,
    //       label: '6 years'
    //     },
    //     {
    //       value: 8,
    //       label: '7 years'
    //     },
    //     {
    //       value: 9,
    //       label: '8 years'
    //     },
    //     {
    //       value: 10,
    //       label: '9 years'
    //     },
    //     {
    //       value: 11,
    //       label: '10 years'
    //     },
    //     {
    //       value: 12,
    //       label: '11 years'
    //     },
    //     {
    //       value: 13,
    //       label: '12 years'
    //     },
    //     {
    //       value: 14,
    //       label: '13 years'
    //     },
    //     {
    //       value: 15,
    //       label: '14 years'
    //     },
    //     {
    //       value: 16,
    //       label: '15 years'
    //     },
    //     {
    //       value: 17,
    //       label: '16 years'
    //     },
    //     {
    //       value: 18,
    //       label: '17 years'
    //     },
    //     {
    //       value: 19,
    //       label: '18 years+'
    //     }
    //   ]
    // },
    // {
    //   question: 'Household Income',
    //   id: 6,
    //   icon: 'las la-wallet',
    //   answers: [
    //     {
    //       value: 1,
    //       label: 'Under 18.000 EUR'
    //     },
    //     {
    //       value: 2,
    //       label: '18.000 - 35.999 EUR'
    //     },
    //     {
    //       value: 3,
    //       label: '36.000 - 58.999 EUR'
    //     },
    //     {
    //       value: 4,
    //       label: '59.000 - 85.999 EUR'
    //     },
    //     {
    //       value: 5,
    //       label: '86.000 - 129.999 EUR'
    //     },
    //     {
    //       value: 6,
    //       label: '130.000 - 176.999 EUR'
    //     },
    //     {
    //       value: 7,
    //       label: '177.000 - 224.999 EUR'
    //     },
    //     {
    //       value: 8,
    //       label: 'Over 225.000 EUR'
    //     },
    //     {
    //       value: 9,
    //       label: 'Do not know/Do not want to state'
    //     }
    //   ]
    // },
    {
      question: 'Education',
      id: 7,
      icon: 'las la-graduation-cap',
      answers: [
        {
          value: 1,
          label: 'School'
        },
        {
          value: 2,
          label: 'Vocational education'
        },
        {
          value: 3,
          label: 'Bachelors degree or similar'
        },
        {
          value: 4,
          label: 'Master degree or similar or above'
        }
      ]
    }
  ],
  behaviours: [
    {
      question: 'Travel Motives',
      id: 4050,

      icon: 'near_me',
      answers: [
        { value: 1, label: 'Leisure in general' },
        { value: 2, label: 'Visiting friends or family' },
        {
          value: 3,
          label:
            'Special occasion travel (e.g. Stag or hen party, anniversary or birthday celebration, wedding or honeymoon)'
        },
        { value: 4, label: 'Volunteering as part of the holiday' },
        {
          value: 5,
          label: 'Combining business and pleasure (extending business travel)'
        },
        {
          value: 6,
          label:
            'Workation (travelling to a destination to work remotely from there)'
        },
        {
          value: 7,
          label: 'Study trips'
        },
        { value: 8, label: 'Medical treatment' },
        {
          value: 9,
          label: 'None/have not traveled in this region'
        }
      ]
    },
    {
      question: 'Preferred holiday type',
      id: 4022,
      icon: 'near_me',
      answers: [
        { value: 1, label: 'Sun and beach holiday' },
        { value: 2, label: 'Skiing holiday' },
        {
          value: 3,
          label: 'Golf holiday'
        },
        { value: 4, label: 'Diving holiday' },
        { value: 6, label: 'Relaxing (unwind, getting into a lower gear)' },
        {
          value: 7,
          label:
            'Cultural holiday (where historical and cultural experiences are the main purpose)'
        },
        { value: 8, label: 'Cruise holiday' },
        {
          value: 9,
          label:
            'Multi destination tour (multiple locations/destinations in one holiday)'
        },

        { value: 11, label: 'Big city holiday' },
        {
          value: 12,
          label: 'Spiritual, pilgrimage or practicing religion'
        },
        { value: 15, label: 'Birdwatching, Safari' },

        {
          value: 17,
          label: 'Attending Festivals, cultural events'
        },

        { value: 19, label: 'Gastronomic/culinary/wine experiences' },
        { value: 24, label: 'Attending Sports events' },
        {
          value: 25,
          label:
            'Attending other events of special interest (tech, media, comics, innovation)'
        },
        { value: 26, label: 'Hiking/trekking holiday' },
        { value: 27, label: 'Cycling holiday (MTB and road cycling)' },
        {
          value: 28,
          label: 'Other active holiday (Climbing, riding, surf/kitesurf, etc.)'
        },
        {
          value: 29,
          label:
            'Health related travel, eg. traveling for the purpose of having an hair transplant'
        },
        { value: 30, label: 'Mountain and wilderness holiday' },
        { value: 31, label: 'Small and unique towns holiday' }
      ]
    },
    {
      question: 'Preferred type of accommodation',
      id: 4021,
      icon: 'luggage',
      answers: [
        {
          value: 1,
          label: 'Camping (caravan, autocamper, mobile home, tent)'
        },
        { value: 2, label: 'Glamping (luxury camping)' },
        {
          value: 3,
          label: 'Boating (house boat, yacht)'
        },
        { value: 4, label: 'Luxury suite/villa' },
        {
          value: 5,
          label: 'Holiday home (not my own privately owned home)'
        },
        {
          value: 6,
          label: 'Private rental (e.g. Airbnb, Homeaway, house swap)'
        },
        {
          value: 7,
          label: 'My own private home at the destination'
        },
        { value: 8, label: 'Bed and Breakfast' },
        { value: 9, label: 'Budget Hotel/Hostel' },
        { value: 10, label: 'Farmhouse' },
        {
          value: 11,
          label: 'Traditional/ Historic property'
        },
        { value: 12, label: '3-4* Hotel' },
        { value: 13, label: 'Luxury Hotel (5+*)' },
        { value: 14, label: 'Boutique Hotel' },
        { value: 15, label: 'City hotel' },
        {
          value: 16,
          label:
            'Globally recognised hotel brand (Hilton, Marriott, Sheraton, etc.)'
        },
        { value: 17, label: 'Resort' },
        { value: 18, label: 'Cruise' },
        { value: 19, label: 'Spa hotel' },
        {
          value: 20,
          label: 'Contemporary style accommodation/design hotel'
        },
        {
          value: 21,
          label: 'Staying with friends or family'
        }
      ]
    },
    {
      question: 'Online Inspiration',
      id: 16,
      icon: 'search',
      answers: [
        {
          value: 2,
          label: 'Facebook'
        },
        {
          value: 3,
          label: 'Instagram'
        },
        {
          value: 4,
          label: 'Snapchat'
        },
        {
          value: 5,
          label: 'Twitter'
        },
        {
          value: 6,
          label: 'Blogs'
        },
        {
          value: 7,
          label: 'Podcasts'
        },
        {
          value: 8,
          label: 'TikTok'
        },
        {
          value: 9,
          label: 'Youtube'
        },
        {
          value: 10,
          label: 'Online reviews sites (Tripadvisor, etc.)'
        },
        {
          value: 12,
          label: 'Online media'
        },
        {
          value: 13,
          label: 'Online lifestyle and travel magazines'
        },
        {
          value: 15,
          label: 'Influencers and celebrities'
        },
        {
          value: 20,
          label: 'Search engines (Google, Bing..)'
        },
        {
          value: 21,
          label: 'Online Travel Agencies'
        },
        {
          value: 22,
          label: 'Travel company websites (airline, hotels, etc.)'
        },
        {
          value: 24,
          label: 'Twitch'
        },
        {
          value: 26,
          label: 'Oficial tourism board / office website'
        },
        {
          value: 31,
          label: 'Whatsapp'
        },
        {
          value: 32,
          label: 'Pinterest'
        },
        {
          value: 33,
          label:
            'TV series on demand (Netfix, HBO, Disney+, Amazon Prime, etc.)'
        },
        {
          value: 34,
          label: 'TV series live'
        }
      ]
    },
    {
      question: 'Inspiration Offline',
      id: 1016,
      icon: 'las la-search-location',
      answers: [
        {
          value: 1,
          label: 'Family & friends'
        },
        {
          value: 11,
          label: 'Newspapers and Supplements'
        },
        {
          value: 16,
          label: 'Cinema/movies'
        },
        {
          value: 17,
          label: 'TV advertising'
        },
        {
          value: 18,
          label: 'Travel TV programmes'
        },
        {
          value: 19,
          label: 'Radio'
        },
        {
          value: 27,
          label: 'Outdoor advertising'
        },
        {
          value: 28,
          label: 'Promotional Events'
        },
        {
          value: 29,
          label: 'Travel agency recommendation / Shop windows'
        },
        {
          value: 30,
          label: 'Lifestyle and travel print magazines'
        }
      ]
    },
    {
      question: 'Booking Channels',
      id: 4070,
      icon: 'store',
      answers: [
        {
          value: 1,
          label: 'Online with a travel agency website - OTA (e.g. Expedia)'
        },
        {
          value: 2,
          label:
            'In person or via phone/email with a travel agency from my region of residence'
        },
        {
          value: 3,
          label: 'Via phone/email with a travel agency from the destination'
        },
        {
          value: 4,
          label: "Directly on providers' websites (e.g., hotels or airlines)"
        },
        {
          value: 5,
          label:
            'Using a price comparison site to book a trip (e.g., Skyscanner, Trivago, Momondo)'
        },
        {
          value: 6,
          label: 'None of these'
        }
      ]
    },
    {
      question: 'Booking Organization',
      id: 4060,
      icon: 'store',
      answers: [
        { value: '1', label: 'With a package' },
        { value: '2', label: 'Separate services' },
        { value: '3', label: 'None/have not traveled in this region' }
      ]
    },
    {
      question: 'Transportation',
      id: 5019,
      icon: 'las la-car',
      answers: [
        { value: 1, label: 'Own vehicle' },
        { value: 2, label: 'Rental Car' },
        { value: 3, label: 'Bus' },
        { value: 4, label: 'Train' },
        {
          value: 5,
          label: 'Flight first class/business class'
        },
        {
          value: 6,
          label: 'Flight premium economy / economy'
        },
        { value: 7, label: 'Ferry' },
        {
          value: 8,
          label: 'Private boats (small cruices / yatching)'
        },
        { value: 9, label: 'Cruise' },
        { value: 10, label: 'Other (bike, etc)' }
      ]
    },
    {
      question: 'Apprehension level',
      id: 1021,
      icon: 'las la-asterisk',
      answers: [
        {
          value: 1,
          label: 'Yes, definitely'
        },
        {
          value: 2,
          label: 'Yes, if I myself feel that it is safe'
        },
        {
          value: 3,
          label: 'Maybe if it is a really good offer'
        },
        {
          value: 4,
          label: 'No'
        }
      ]
    },
    {
      question: 'Social And Environmental Responsibility',
      id: 1019,
      icon: 'las la-dove',
      answers: [
        {
          value: 1,
          label: 'Compensated CO2 emissions'
        },
        {
          value: 2,
          label: 'Chosen a train or bus over a plane ticket'
        },
        {
          value: 3,
          label:
            'Taken part in a rural / local community experience to share their domestic life'
        },
        {
          value: 4,
          label: 'Supported a social conservation project (activism)'
        },
        {
          value: 5,
          label:
            'Supported a environmental / biodiversity conservation project (activism)'
        },
        {
          value: 6,
          label:
            'Chosen ecofriendly accommodation in spite of costing more than a regular one'
        },
        {
          value: 7,
          label: 'None of the above'
        }
      ]
    }
  ],
  catalysts: [
    {
      question:
        'Cultural & Historical Experiences (Museums, cultural & historical sites)',
      id: 167,
      icon: 'las la-landmark'
    },
    {
      question: 'Opportunities for going to theme parks',
      id: 143,
      icon: 'las la-laugh-beam'
    },
    {
      question: 'Going to the beach',
      id: 137,
      icon: 'las la-umbrella-beach'
    },
    {
      question: 'Shopping',
      id: 132,
      icon: 'las la-shopping-bag'
    },
    {
      question: 'Being active (Sport, adventure)',
      id: 148,
      icon: 'las la-running'
    },
    {
      question: 'Wellness/Spa',
      id: 139,
      icon: 'las la-spa'
    },
    {
      question: 'Nature/outdoor experiences',
      id: 133,
      icon: 'las la-mountain'
    },
    {
      question: 'Big city experiences',
      id: 150,
      icon: 'las la-city'
    },
    {
      question: 'Food experiences',
      id: 140,
      icon: 'las la-utensils'
    },
    {
      question: 'Fine dining',
      id: 141,
      icon: 'las la-concierge-bell'
    },
    {
      question:
        'Gaining a new skill/developing skill, e.g. language, cooking or similar',
      id: 138,
      icon: 'las la-sign-language'
    },
    {
      question: 'Interacting with locals',
      id: 153,
      icon: 'las la-language'
    },
    {
      question: 'All inclusive accommodation options',
      id: 158,
      icon: 'las la-wallet'
    },
    {
      question: 'Nightlife',
      id: 164,
      icon: 'las la-glass-cheers'
    },
    {
      question: 'Photography',
      id: 165,
      icon: 'las la-camera'
    },
    {
      question:
        'Agenda of Sport Events (Football World cup / Regional tournaments / Wimbledon / Olympics / Formula1)',
      id: 168,
      icon: 'las la-basketball-ball'
    },
    {
      question: 'Agenda of Festivals, Concerts & Events',
      id: 169,
      icon: 'las la-theater-masks'
    },
    {
      question:
        'The possibility to practice a specific preferred activity as ski, diving, surf, kitesurf, golf, etc.',
      id: 181,
      icon: 'las la-praying-hands'
    },
    {
      question: 'Going to the mountain and wilderness',
      id: 184,
      icon: 'las la-mountain'
    },
    {
      question: 'Visiting small and unique towns',
      id: 185,
      icon: 'las la-igloo'
    },
    {
      question:
        'Possibility of a spiritual experience, pilgrimage or practice religion',
      id: 180,
      icon: 'las la-praying-hands'
    }
  ],
  enablers: [
    {
      question: 'Opportunities to make social media content',
      id: 182,
      icon: 'las la-hashtag'
    },
    {
      question: 'Price level in the country (affordability)',
      id: 127,
      icon: 'las la-hand-holding-usd'
    },
    {
      question: 'Environmental concerns and sustainability',
      id: 128,
      icon: 'las la-leaf'
    },
    {
      question: 'Safety standards/low crime levels',
      id: 129,
      icon: 'las la-shield-alt'
    },
    {
      question: 'Cleanliness',
      id: 131,
      icon: 'las la-broom'
    },
    {
      question: 'Guided/Arranged tours/experiences',
      id: 149,
      icon: 'las la-users'
    },
    {
      question: 'Child friendliness',
      id: 130,
      icon: 'las la-baby-carriage'
    },
    {
      question: 'That the destination has few tourists',
      id: 142,
      icon: 'las la-user-alt-slash'
    },
    {
      question: 'Living new experiences',
      id: 151,
      icon: 'las la-fire-alt'
    },
    {
      question: 'Meeting new people',
      id: 152,
      icon: 'las la-user-friends'
    },
    {
      question: 'Easy access to health and medical facilities',
      id: 154,
      icon: 'las la-ambulance'
    },
    {
      question: 'Accessibility for less mobile',
      id: 155,
      icon: 'las la-wheelchair'
    },
    {
      question: 'LGBTQ+- friendliness',
      id: 156,
      icon: 'las la-mercury'
    },
    {
      question: 'Direct flight',
      id: 159,
      icon: 'las la-plane'
    },
    {
      question: 'Flights from my local airport',
      id: 160,
      icon: 'las la-plane-departure'
    },
    {
      question: 'Being able to drive to the destination',
      id: 161,
      icon: 'las la-truck-pickup'
    },
    {
      question: 'Health and hygiene standards',
      id: 162,
      icon: 'las la-notes-medical'
    },
    {
      question: 'Pet friendliness',
      id: 163,
      icon: 'las la-dog'
    },
    {
      question:
        'Availability of VIP exclusive personal services (personal butler/maid/chef/personal shopper)',
      id: 166,
      icon: 'las la-wallet'
    },
    {
      question: 'Backpacker friendliness',
      id: 170,
      icon: 'backpack'
    },
    {
      question: 'Premium/luxury accommodation options',
      id: 183,
      icon: 'las la-wallet'
    }
  ],
  plannings: [
    {
      question: 'Annual household holiday budget',
      id: 8,
      icon: 'legend_toggle',
      answers: [
        {
          value: 1,
          label: '0-1.000 EUR'
        },
        {
          value: 2,
          label: '1.000-2.999 EUR'
        },
        {
          value: 3,
          label: '3.000-4.999 EUR'
        },
        {
          value: 4,
          label: '5.000-9.999 EUR'
        },
        {
          value: 5,
          label: '10.000-19.999 EUR'
        },
        {
          value: 6,
          label: '20.000-29.999 EUR'
        },
        {
          value: 7,
          label: '30.000-39.999 EUR'
        },
        {
          value: 8,
          label: '40.000-49.999 EUR'
        },
        {
          value: 9,
          label: '50000 EUR or more'
        },
        {
          value: 10,
          label: 'Do not know/Do not want to state'
        }
      ]
    },
    {
      question: 'Budget compared to previous year',
      id: 9,
      icon: 'legend_toggle',
      answers: [
        {
          value: 1,
          label: 'Less than last year'
        },
        {
          value: 2,
          label: 'Same as last year'
        },
        {
          value: 3,
          label: 'More than last year'
        },
        {
          value: 4,
          label: 'Do not know'
        }
      ]
    },
    {
      question: 'Domestic Short holidays (up to 4 days)',
      id: 1274,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: 'January'
        },
        {
          value: 2,
          label: 'February'
        },
        {
          value: 3,
          label: 'March'
        },
        {
          value: 4,
          label: 'April'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'June'
        },
        {
          value: 7,
          label: 'July'
        },
        {
          value: 8,
          label: 'August'
        },
        {
          value: 9,
          label: 'September'
        },
        {
          value: 10,
          label: 'October'
        },
        {
          value: 11,
          label: 'November'
        },
        {
          value: 12,
          label: 'December'
        },
        {
          value: 13,
          label: 'None'
        }
      ]
    },
    {
      question: 'Domestic Long holidays (5 days or more)',
      id: 1111,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: 'January'
        },
        {
          value: 2,
          label: 'February'
        },
        {
          value: 3,
          label: 'March'
        },
        {
          value: 4,
          label: 'April'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'June'
        },
        {
          value: 7,
          label: 'July'
        },
        {
          value: 8,
          label: 'August'
        },
        {
          value: 9,
          label: 'September'
        },
        {
          value: 10,
          label: 'October'
        },
        {
          value: 11,
          label: 'November'
        },
        {
          value: 12,
          label: 'December'
        },
        {
          value: 13,
          label: 'None'
        }
      ]
    },
    {
      question: 'International Short holidays (up to 4 days)',
      id: 1112,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: 'January'
        },
        {
          value: 2,
          label: 'February'
        },
        {
          value: 3,
          label: 'March'
        },
        {
          value: 4,
          label: 'April'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'June'
        },
        {
          value: 7,
          label: 'July'
        },
        {
          value: 8,
          label: 'August'
        },
        {
          value: 9,
          label: 'September'
        },
        {
          value: 10,
          label: 'October'
        },
        {
          value: 11,
          label: 'November'
        },
        {
          value: 12,
          label: 'December'
        },
        {
          value: 13,
          label: 'None'
        }
      ]
    },
    {
      question: 'International Long holidays (5 days or more)',
      id: 1113,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: 'January'
        },
        {
          value: 2,
          label: 'February'
        },
        {
          value: 3,
          label: 'March'
        },
        {
          value: 4,
          label: 'April'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'June'
        },
        {
          value: 7,
          label: 'July'
        },
        {
          value: 8,
          label: 'August'
        },
        {
          value: 9,
          label: 'September'
        },
        {
          value: 10,
          label: 'October'
        },
        {
          value: 11,
          label: 'November'
        },
        {
          value: 12,
          label: 'December'
        },
        {
          value: 13,
          label: 'None'
        }
      ]
    },
    {
      question: 'European Short holidays (up to 4 days)',
      id: 1114,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: 'January'
        },
        {
          value: 2,
          label: 'February'
        },
        {
          value: 3,
          label: 'March'
        },
        {
          value: 4,
          label: 'April'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'June'
        },
        {
          value: 7,
          label: 'July'
        },
        {
          value: 8,
          label: 'August'
        },
        {
          value: 9,
          label: 'September'
        },
        {
          value: 10,
          label: 'October'
        },
        {
          value: 11,
          label: 'November'
        },
        {
          value: 12,
          label: 'December'
        },
        {
          value: 13,
          label: 'None'
        }
      ]
    },
    {
      question: 'European Long holidays (5 days or more)',
      id: 1115,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: 'January'
        },
        {
          value: 2,
          label: 'February'
        },
        {
          value: 3,
          label: 'March'
        },
        {
          value: 4,
          label: 'April'
        },
        {
          value: 5,
          label: 'May'
        },
        {
          value: 6,
          label: 'June'
        },
        {
          value: 7,
          label: 'July'
        },
        {
          value: 8,
          label: 'August'
        },
        {
          value: 9,
          label: 'September'
        },
        {
          value: 10,
          label: 'October'
        },
        {
          value: 11,
          label: 'November'
        },
        {
          value: 12,
          label: 'December'
        },
        {
          value: 13,
          label: 'None'
        }
      ]
    },
    {
      question: 'European Short holidays (up to 4 days)',
      id: 1131,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
        {
          value: 5,
          label: '5'
        },
        {
          value: 6,
          label: '6'
        },
        {
          value: 7,
          label: '7'
        },
        {
          value: 8,
          label: '8'
        },
        {
          value: 9,
          label: '9'
        },
        {
          value: 10,
          label: '10+'
        },
        {
          value: 11,
          label: 'None'
        }
      ]
    },
    {
      question: 'European Long holidays (5 days or more)',
      id: 1132,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
        {
          value: 5,
          label: '5'
        },
        {
          value: 6,
          label: '6'
        },
        {
          value: 7,
          label: '7'
        },
        {
          value: 8,
          label: '8'
        },
        {
          value: 9,
          label: '9'
        },
        {
          value: 10,
          label: '10+'
        },
        {
          value: 11,
          label: 'None'
        }
      ]
    },
    {
      question: 'International outside Europe Short holidays (up to 4 days)',
      id: 1117,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
        {
          value: 5,
          label: '5'
        },
        {
          value: 6,
          label: '6'
        },
        {
          value: 7,
          label: '7'
        },
        {
          value: 8,
          label: '8'
        },
        {
          value: 9,
          label: '9'
        },
        {
          value: 10,
          label: '10+'
        },
        {
          value: 11,
          label: 'None'
        }
      ]
    },
    {
      question: 'International outside Europe Long holidays (5 days or more)',
      id: 1118,
      icon: 'event_note',
      answers: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
        {
          value: 5,
          label: '5'
        },
        {
          value: 6,
          label: '6'
        },
        {
          value: 7,
          label: '7'
        },
        {
          value: 8,
          label: '8'
        },
        {
          value: 9,
          label: '9'
        },
        {
          value: 10,
          label: '10+'
        },
        {
          value: 11,
          label: 'None'
        }
      ]
    }
  ],
  barriers: [
    {
      question: 'Political instability in destination',
      id: 1617,
      icon: 'las la-city'
    },
    {
      question: 'Political instability in my country',
      id: 1618,
      icon: 'las la-landmark'
    },
    {
      question: 'Threat of terrorist attack',
      id: 1619,
      icon: 'las la-shield-alt'
    },
    {
      question: 'Global health concerns (covid, monkey pox)',
      id: 1620,
      icon: 'las la-heart'
    },
    {
      question: 'International conflicts',
      id: 1621,
      icon: 'las la-exclamation-triangle'
    },
    {
      question: 'Inconvenience in airports (delays/cancellations)',
      id: 1622,
      icon: 'las la-plane-arrival'
    },
    {
      question: 'Increase of cost of holidays',
      id: 1623,
      icon: 'las la-umbrella-beach'
    },
    {
      question: 'Cost of living increase affecting disposable income',
      id: 1624,
      icon: 'las la-money-bill'
    },
    {
      question: 'Natural disasters or extreme weather at the destination',
      id: 1625,
      icon: 'las la-snowflake'
    }
  ],
  factors: []
};

export default filterOptions2024B;
